import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import {
  get1BpersonalInfo,
  getAppId,
  getEmail,
  getStageID,
  setApplicantBirthDate,
  setTStageID,
} from "../utility/Common";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { createNotification } from "./Popup";
import { applicationManagementMasilingi } from "../utility/services/apiService";
import { getResource } from "../utility/services/resources";
import { messages } from "../utility/services/message";
import NavBar_appID from "./layout/NavBar_appID";

import DatePicker from "react-date-picker";
import "../includes/css/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import CentryReusableComponent from "./CentryReusableComponent";
import { personalInfo } from "../formValidation/FormValidator";

function Step_one() {
  let navigate = useNavigate();
  // const personalInfoData = useLocation();
  // var Stage = personalInfoData?.state?.DocStageID;
  var Stage = +getStageID();
  const { checkApplicationStage } = CentryReusableComponent({});
  const [regionsId, setRegionID] = useState();
  const [FirstName, setFirstName] = useState("");
  const [MiddleName, setMiddleName] = useState("");
  const [FamilyName, setFamilyName] = useState("");
  const [GenderID, setGenderID] = useState("");
  const [DateofBirth, setDateofBirth] = useState("");
  const [BirthVillage, setBirthVillage] = useState("");
  const [wards, setWards] = useState([]);

  const [countryId, setCountryID] = useState();
  const [territoryID, setTerritoryID] = useState();
  const [districtsId, setDistrictsID] = useState();
  const [districts, setDistricts] = useState([]);
  const [wardsId, setWardsID] = useState();
  const [regions, setRegions] = useState([]);
  const [territories, setTerritories] = useState([]);
  const [countries, setCountries] = useState([]);
  const [AnyOtherID, setAnyOtherID] = useState("");
  const [stageID, setStageID] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  //======Lookups
  useEffect(() => {
    fetchCountries();
    setPersonalnfo();
  }, []);

  const setPersonalnfo = () => {
    checkApplicationStage(2);
    //const data = personalInfoData?.state;
    const data = get1BpersonalInfo();
    setStageID(data?.DocStageID);
    setCountryID(data?.CountryID);

    setTerritoryID(data?.TeritoryID);
    if (data?.CountryID) {
      fetchTerritory(data?.CountryID);
    }
    setRegionID(data?.RegionID);
    if (data?.TeritoryID) {
      fetchRegions(data?.TeritoryID, data?.CountryID);
    }
    setDistrictsID(data?.DistrictID);
    if (data?.RegionID) {
      fetchDistricts(data?.RegionID);
    }
    setWardsID(data?.BirthWardID);
    if (data?.DistrictID) {
      fetWards(data?.DistrictID);
    }
    setBirthVillage(data?.BirthVillage);

    setFamilyName(data?.FamilyName);
    setFirstName(data?.FirstName);
    setMiddleName(data?.MiddleName);
    setGenderID(data?.GenderID);
    setDateofBirth(data?.ApplicantDoB);
    setFirstName(data?.FirstName);
  };

  //======fetchCountries
  const fetchCountries = async () => {
    const result = await getResource("Country", "null", "null", "lookup");
    if (Array.isArray(result) && result.length > 0) {
      setCountries(result);
    } else {
      setCountries([]);
    }
  };

  //======selectCountry
  const getCountryIDChange = (e) => {
    const countryID = e.target.value;
    setCountryID(countryID);
    setWardsID(countryID);
    fetchTerritory(countryID);
  };
  const fetchTerritory = async (territoryId) => {
    const result = await getResource(
      "TerritoryByCountry",
      territoryId,
      "null",
      "lookup",
    );
    if (Array.isArray(result) && result.length > 0) {
      setTerritories(result);
    } else {
      setTerritories([]);
    }
  };

  //======selectTerritory
  const getTerritoryIDChange = (e) => {
    const territoryID = e.target.value;
    setTerritoryID(territoryID);
    fetchRegions(territoryID, countryId);
  };

  const fetchRegions = async (territoryID, countryID) => {
    const result = await getResource(
      "RegionBirth",
      territoryID,
      countryID,
      "lookup",
    );
    if (Array.isArray(result) && result.length > 0) {
      setRegions(result);
    } else {
      setRegions([]);
    }
  };

  //======selectRegion
  const getRegionIDChange = (e) => {
    const regionID = e.target.value;
    setRegionID(regionID);
    fetchDistricts(regionID);
  };
  const fetchDistricts = async (regionID) => {
    const result = await getResource(
      "DistrictByRegionID",
      regionID,
      "null",
      "lookup",
    );
    if (Array.isArray(result) && result.length > 0) {
      setDistricts(result);
    } else {
      setDistricts([]);
    }
  };

  //======selectDistrict
  const getDistrictIDChange = (e) => {
    const districtID = e.target.value;
    setDistrictsID(districtID);
    fetWards(districtID);
  };
  const fetWards = async (districtId) => {
    const result = await getResource(
      "WardByDistrict",
      districtId,
      "null",
      "lookup",
    );
    if (Array.isArray(result) && result.length > 0) {
      setWards(result);
    } else {
      setWards([]);
    }
  };

  const handleDateChange = (date) => {
    if (date) {
      const utcDate = new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
      );
      setDateofBirth(utcDate);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    //Refresh
    const Stage = stageID ?? 210;

    const formData = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
      Action: Stage == 210 ? "Insert" : "Update",
      AnyOtherID,
      BirthVillage: BirthVillage,
      BirthWardID: wardsId,
      DateofBirth,
      FamilyName,
      FirstName,
      GenderID,
      MiddleName,
    };

    const navigateToStage = (stage, message) => {
      const routes = {
        210: "/stp1",
        220: "/stp2",
        230: "/stp3",
        240: "/stp4",
        250: "/stp5",
        260: "/stp6",
        270: "/stp7",
      };
      navigate(routes[stage] || "/continue");
      createNotification({ type: "success", message })();
    };

    const newErrors = personalInfo(formData);
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setErrors({});
      setIsLoading(true);

      applicationManagementMasilingi(formData, "add-personal-info")
        .then((result) => {
          setIsLoading(false);
          if (result.code == 1) {
            if (result.data) {
              const stID = result?.data[0]?.StageID;
              setTStageID(stID);
            }
            if (Stage == 210 && formData.Action === "Insert") {
              navigate("/stp2");
            } else if (Stage == 220 && formData.Action === "Update") {
              navigate("/stp2");
            } else {
              navigateToStage(Stage, result.message);
            }
            setApplicantBirthDate(result?.data[0]?.DateOfBirth);
            setStageID(result?.data[0]?.StageID);
          } else if (
            result.code == 3 ||
            result.message.toLowerCase().includes("expire")
          ) {
            createNotification({ type: "error", message: "Session expired" })();
            navigate("/");
          } else {
            createNotification({ type: "error", message: result.message })();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
          createNotification({
            type: "error",
            message: messages.networkError,
          })();
        });
    }
  };

  return (
    <>
      <Header />
      <div className="container">
        <NavBar_appID />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 tab-registration-menu hidden-xs">
                <div className="list-group">
                  <Link to="#" className="list-group-item active">
                    Habari Binafsi
                  </Link>
                  <Link className="list-group-item ">Anuwani ya Makazi </Link>
                  <Link className="list-group-item ">Habari za Wazazi </Link>
                  <Link className="list-group-item ">Habari za Safari</Link>
                  <Link className="list-group-item ">Wakati wa Dharura</Link>
                  <Link className="list-group-item ">Viambatanisho </Link>
                  <Link className="list-group-item ">Tamko Rasmi </Link>
                  <Link className="list-group-item ">Malipo </Link>
                </div>
              </div>
              <div
                className="col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-registration-tab"
                style={{ marginTop: "1px", paddingRight: "1px" }}
              >
                <div className="tab-registration-content active">
                  <form id="step-one-form" onSubmit={handleSubmit}>
                    <div className="box box-default">
                      <div className="box-header with-border">
                        <h3 className="box-title">Taarifa Binafsi</h3>
                      </div>
                      <div className="box-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Jina la Kwanza
                              </label>
                              <input
                                type="text"
                                id="FirstName"
                                className="form-control"
                                name="FirstName"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z '-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setFirstName(value);
                                  }
                                }}
                                value={FirstName}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                className="control-label"
                                htmlFor="MiddleName"
                              >
                                Jina la Kati
                              </label>
                              <input
                                type="text"
                                id="MiddleName"
                                className="form-control"
                                name="MiddleName"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z '-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setMiddleName(value);
                                  }
                                }}
                                value={MiddleName}
                                aria-required="true"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Jina la Ukoo
                              </label>
                              <input
                                type="text"
                                id="FamilyName"
                                className="form-control"
                                name="FamilyName"
                                onChange={(e) => {
                                  const regex = /^[a-zA-Z '-]*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setFamilyName(value);
                                  }
                                }}
                                value={FamilyName}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Jinsia</label>
                              <select
                                id="GenderID"
                                className="form-control"
                                name="GenderID"
                                onChange={(e) => setGenderID(e.target.value)}
                                value={GenderID}
                                required
                              >
                                <option value="">Chagua Jinsia</option>
                                <option value="1">ME</option>
                                <option value="2">KE</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4 required">
                            <label className="control-label">
                              Tarehe ya Kuzaliwa
                            </label>
                            <DatePicker
                              id="DateofBirth"
                              onChange={handleDateChange}
                              value={DateofBirth ? new Date(DateofBirth) : ""}
                              minDate={new Date(1900, 0, 1)}
                              maxDate={new Date()}
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="box box-default">
                      <div className="box-header with-border">
                        <h3 className="box-title">Mahali pa Kuzaliwa</h3>
                      </div>
                      <div className="box-body" style={{ display: "block" }}>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Nchi</label>
                              <select
                                id="BirthCountryID"
                                className="form-control"
                                name="BirthCountryID"
                                onChange={getCountryIDChange}
                                value={countryId}
                                required
                              >
                                <option value="">Chagua Nchi</option>
                                {countries.length > 0 &&
                                  countries?.map((country) => (
                                    <option
                                      key={country.id}
                                      value={country.ResourceID}
                                    >
                                      {country.ResourceName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Eneo</label>
                              <select
                                id="eneo"
                                className="form-control"
                                name="eneo"
                                onChange={getTerritoryIDChange}
                                value={territoryID}
                                required
                              >
                                <option value="">Chagua Eneo</option>
                                {territories.length > 0 &&
                                  territories?.map((territory) => (
                                    <option
                                      key={territory.id}
                                      value={territory.ResourceID}
                                    >
                                      {territory.ResourceName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Mkoa</label>
                              <select
                                id="mkoa"
                                className="form-control"
                                onChange={getRegionIDChange}
                                value={regionsId}
                                name="mkoa"
                                required
                              >
                                <option value="">Chagua Mkoa</option>
                                {regions.length > 0 &&
                                  regions?.map((region) => (
                                    <option
                                      key={region.ResourceID}
                                      value={region.ResourceID}
                                    >
                                      {region.ResourceName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">Wilaya</label>
                              <select
                                id="DistrictID"
                                className="form-control"
                                value={districtsId}
                                onChange={getDistrictIDChange}
                                name="DistrictID"
                                required
                              >
                                <option value="">Chagua Wilaya</option>
                                {districts.length > 0 &&
                                  districts?.map((district) => (
                                    <option
                                      key={district.ResourceID}
                                      value={district.ResourceID}
                                    >
                                      {district.ResourceName}
                                    </option>
                                  ))}{" "}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Kata/Shehia
                              </label>
                              <select
                                id="BirthWardID"
                                className="form-control"
                                name="BirthWardID"
                                onChange={(e) => setWardsID(e.target.value)}
                                value={wardsId}
                                required
                              >
                                <option value="">Chagua Kata/Shehia</option>
                                {wards.length > 0 &&
                                  wards?.map((ward) => (
                                    <option
                                      key={ward.ResourceID}
                                      value={ward.ResourceID}
                                    >
                                      {ward.ResourceName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label className="control-label">
                                Mtaa/Kijiji
                              </label>
                              <input
                                type="text"
                                id="BirthVillage"
                                className="form-control"
                                name="BirthVillage"
                                onChange={(e) => {
                                  const regex =
                                    /^(?! )[a-zA-Z]+(?:[ '-][a-zA-Z]+)*$/;
                                  const value = e.target.value.toUpperCase();
                                  if (regex.test(value) || value === "") {
                                    setBirthVillage(value);
                                  }
                                }}
                                value={BirthVillage}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {errors && (
                        <div className="help-block help-block-error">
                          {Object.values(errors).map((error, index) => (
                            <p
                              className="help-block help-block-error"
                              key={index}
                            >
                              {error}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="box-footer">
                      <div className="row">
                        <div className="col-md-4">
                          <Link
                            to="/"
                            type="submit"
                            className="btn btn-labeled btn-block btn-default"
                          >
                            Hifadhi na Toka | <i className="fa fa-save"></i>
                          </Link>
                        </div>
                        <div className="col-md-4"></div>
                        <div className="col-md-4">
                          <button
                            tpye="submit"
                            className="btn btn-default btn-block btn-label-next"
                            disabled={isLoading}
                          >
                            {isLoading ? "Subiri.." : "Hifadhi na Endelea |"}
                            <i className="fa fa-angle-double-right"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Step_one;
